'use client'

/**
 * The logo on a sign-in button that leaves for a provider (branded sign-in, 3 Nov 2026; screens A1 to A7): the
 * Microsoft squares and the Google G, the same marks today's sign-in page draws, and a building for a company's SAML or
 * other OpenID Connect provider (the mark the "Sign in with SSO" button already uses). Decorative: the button's words
 * name the provider.
 */

import { Building2 } from 'lucide-react'
import { cn } from '@/lib/utils'

export function SignInProviderIcon({
  provider,
  className,
}: {
  provider: 'microsoft' | 'google' | 'saml' | 'oidc'
  className?: string
}) {
  const shape = cn('h-4 w-4 shrink-0', className)
  if (provider === 'microsoft') {
    return (
      <svg className={shape} viewBox="0 0 21 21" fill="none" aria-hidden="true">
        <rect x="1" y="1" width="9" height="9" fill="#F25022" />
        <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
        <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
        <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
      </svg>
    )
  }
  if (provider === 'google') {
    return (
      <svg className={shape} viewBox="0 0 24 24" aria-hidden="true">
        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92a5.06 5.06 0 0 1-2.2 3.32v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.1z" fill="#4285F4" />
        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853" />
        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05" />
        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335" />
      </svg>
    )
  }
  return <Building2 className={shape} aria-hidden="true" />
}
